import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { CitizensServicesGroups } from './citizens-services-groups.model';
import * as CitizensServicesGroupsActions from './citizens-services-groups.actions';

export const citizensServicesGroupsesFeatureKey = 'citizensServicesGroupses';

export interface State extends EntityState<CitizensServicesGroups> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensServicesGroups> = createEntityAdapter<CitizensServicesGroups>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensServicesGroupsActions.addCitizensServicesGroups,
    (state, action) => adapter.addOne(action.citizensServicesGroups, state)
  ),
  on(CitizensServicesGroupsActions.upsertCitizensServicesGroups,
    (state, action) => adapter.upsertOne(action.citizensServicesGroups, state)
  ),
  on(CitizensServicesGroupsActions.addCitizensServicesGroupss,
    (state, action) => adapter.addMany(action.citizensServicesGroupss, state)
  ),
  on(CitizensServicesGroupsActions.upsertCitizensServicesGroupss,
    (state, action) => adapter.upsertMany(action.citizensServicesGroupss, state)
  ),
  on(CitizensServicesGroupsActions.updateCitizensServicesGroups,
    (state, action) => adapter.updateOne(action.citizensServicesGroups, state)
  ),
  on(CitizensServicesGroupsActions.updateCitizensServicesGroupss,
    (state, action) => adapter.updateMany(action.citizensServicesGroupss, state)
  ),
  on(CitizensServicesGroupsActions.deleteCitizensServicesGroups,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensServicesGroupsActions.deleteCitizensServicesGroupss,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensServicesGroupsActions.loadCitizensServicesGroupss,
    (state, action) => adapter.setAll(action.citizensServicesGroupss, state)
  ),
  on(CitizensServicesGroupsActions.clearCitizensServicesGroupss,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
